import {createStyles} from '@material-ui/core';
import {defaultFont} from '../../styles/style';

export const style = createStyles({
  container: {
    padding: '8px',
    height: '100%',
    overflowY: 'auto',
  },
  domainButton: {
    ...defaultFont,
    'textTransform': 'none',
    'width': '100%',
    'padding': 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
});
